import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClientService } from '@core/service/client.service';
import { Client } from '@core/model/client.model';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '@app/core';

@Component({
  selector: 'app-create-cliente',
  templateUrl: './create-cliente.component.html',
  styleUrls: ['./create-cliente.component.css']
})
export class CreateClientComponent implements OnInit {
  clientForm: FormGroup;
  clients: Client[];
  @Input() title: string;
  @Input() cliente_id: string;
  @Input() estado: boolean;
  isLoading = false;
  // subir foto
  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  imagenURL: any = {};
  progress = 0;
  currentUserSubscription: Subscription;

  currentUser: any;
  userid: string;
  constructor(
    private formBuilder: FormBuilder,
    private clientService: ClientService,
    public activeModal: NgbActiveModal,
    private authService: AuthenticationService
  ) {
    this.currentUserSubscription = this.authService.currentUser.subscribe(
      user => {
        this.currentUser = user.data.user.id;
        //  console.log(this.currentUser.data.user);
        this.userid = this.currentUser;
      }
    );
  }

  ngOnInit() {
    this.createForm();
    // console.log(this.cliente_id);
    const id = this.cliente_id;

    // console.log(id);
    if (this.estado === true) {
      this.clientService.getById(id).subscribe(data => {
        // console.log(data);
        // this.categoryForm.setValue(data);
        this.clientForm.setValue({
          nombres: data.nombres,
          apellidos: data.apellidos,
          ci_nit: data.ci_nit,
          email: data.email,
          direccion: data.direccion,
          celular: data.celular,
          telefono: data.telefono,
          entidad: data.entidad
        });
      });
    }
  }
  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }
  preview() {
    // Show preview
    const mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = _event => {
      this.previewUrl = reader.result;
    };
  }

  createForm() {
    this.clientForm = this.formBuilder.group({
      nombres: ['', [Validators.required]],
      apellidos: ['', [Validators.required]],
      ci_nit: ['', [Validators.required]],
      direccion: ['', [Validators.required]],
      email: [''],
      entidad: ['', [Validators.required]],
      // latitud: ['', [Validators.required]],
      // longitud: ['', [Validators.required]],
      // foto: ['', [Validators.required]],
      celular: [''],
      telefono: ['']
    });
  }

  listClient() {
    this.clientService.getAll().subscribe(
      data => {
        this.clients = data;
        console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  registerClient() {
    const formData = new FormData();

    formData.append('file', this.fileData);
    formData.append('nombres', this.clientForm.value.nombres);
    formData.append('apellidos', this.clientForm.value.apellidos);
    formData.append('ci_nit', this.clientForm.value.ci_nit);
    formData.append('direccion', this.clientForm.value.direccion);
    formData.append('email', this.clientForm.value.email);
    formData.append('entidad', this.clientForm.value.entidad);
    // formData.append('stock', this.productsForm.value.stock);
    formData.append('celular', this.clientForm.value.celular);
    formData.append('user_id', this.userid);
    // formData.append('_method', 'PUT');
    console.log(this.userid);
    // newClient.latitud=this.clientForm.value.latitud;
    // newClient.longitud=this.clientForm.value.longitud;
    if (this.estado === true) {
      formData.append('_method', 'PUT');

      this.isLoading = true;

      this.clientService
        .updateCliente(this.cliente_id, formData)
        .pipe(
          finalize(() => {
            this.clientForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire(data);
            this.clientForm.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    } else {
      this.isLoading = true;
      this.clientService
        .create(formData)
        .pipe(
          finalize(() => {
            this.clientForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire(data);
            this.clientForm.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    }
  }
}
